import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { Category } from "../../categories.types";
import { requestGetAllCategories } from "./getAllCategories.request";

const QUERY_KEY = ["category-admin", "all"];

const useGetAllCategories = (
  options?: QueryOptions<Category[], ApiServiceError<ApiError>>
) => {
  const { data: categories = [], ...rest } = useQuery({
    queryKey: QUERY_KEY,
    queryFn: requestGetAllCategories,
    ...options
  });

  return { categories, ...rest };
};

export default useGetAllCategories;
